export function insertCharacterAtCursor(
	textarea: HTMLTextAreaElement,
	char: string
): void {
	const start = textarea.selectionStart
	const end = textarea.selectionEnd

	textarea.value =
		textarea.value.slice(0, start) + char + textarea.value.slice(end)
	textarea.selectionStart = textarea.selectionEnd = start + char.length

	textarea.focus()
	// update react listener if enabled
	textarea.dispatchEvent(new Event('input', { bubbles: true }))
}
